export default "__VITE_ASSET__69519ef9__"